
@if (!control && bas.envtest) {
  <div class="fgc-red">
    control is undefined
  </div>
}
@if (control && control.controlType != 'hidden'  && (control.show === undefined || control.show(control))) {
  <nz-form-item
    [formGroup]="form"
  [class]="''
    + 'bt-form-item'
    + ' fi-' + control.controlType 
    + ' fi-key-' + control.key 
    + ' ' + (control.data.css  || '')
    + ' ' + (options.css || '') 
    "
    [class.fi-nomargin]="control.data.nomargin || options.nomargin"
    [class.fi-checkboxMarginTop]="control.controlType == 'checkbox' && (options.checkboxMarginTop || control.data.checkboxMarginTop) && !options.hideLabel"
  [class.fi-nolabel]="
       !(control.controlType != 'checkbox' 
    && control.controlType != 'upload'  
    && control.controlType != 'checkbox-list' 
    && (control.mk || control.label)
    && !options.hideLabel)"
    >
    @if (control.controlType != 'checkbox'
      && control.controlType != 'upload'
      && control.controlType != 'checkbox-list'
      && (control.mk || control.label)
      && !options.hideLabel) {
      <nz-form-label
        [attr.for]="control.key"
        [class.text-center]="control.data.alignCenter"
        >
        <!--    [class.text-right]="control.controlType == 'label' && control.data.alignRight" -->
        {{ control.mk ? (control.mk | actrans) : control.label }}
        @if (options.showRequiredStar && control.required) {
          <span>&nbsp;*</span>
        }
        @if (control.mkInfo) {
          <i
            class="mkInfoIcon"
            nz-icon [nzType]="'info-circle'"
            nz-tooltip
            [nzTooltipTitle]="mkInfoTemplate"
            >
            <!--  [nzTooltipTitle]="control.mkInfo | actrans | str"  -->
            <ng-template #mkInfoTemplate>
              <span class="text-sm" [innerHtml]="control.mkInfo | actrans"></span>
            </ng-template>
          </i>
        }
      </nz-form-label>
    }
    <!-- <div *ngIf="bas.envtest">
    (controlType: {{ control.controlType  }})
  </div> -->
  <nz-form-control [nzErrorTip]="control.required ? ('app.lib.error.form.required' | actrans | str) : undefined">

     
    @if (control.data.parentType != "message" &&  (control.controlType == 'richtext' || control.data.editHtmlEnabled)) {
      @if ( this.bas.aas.isBn()) { <!--control.data.editHtml &&-->
          <nz-form-item>
            <nz-form-control >
              <label nz-checkbox [(ngModel)]="control.data.editHtmlEnabled" [ngModelOptions]="{standalone: true}" (ngModelChange)="onHtmlChange($event)">
                {{ 'common.form.editHtml' | actrans }}</label>
            </nz-form-control>
          </nz-form-item>
        }
      }



    <!--  [nzSm]="14" [nzXs]="24" -->
    @if (control.controlType == 'input') {
      <nz-input-group
        [nzSuffix]="control.data.suffix" [nzPrefix]="control.data.prefix">
        <input nz-input
          [formControlName]="control.key"
          [placeholder]="control.placeholder | actrans | str"
          [id]="control.key"
          [type]="control.type"
          [nzSize]="control.size ? (control.size == 'small' ? 'small' : (control.size == 'large' ? 'large' : 'default') ) : 'default'"
          [required]="control.required"
          [readonly]="control.data.readOnly"
          [min]="control.data.min !== undefined ? control.data.min : undefined"
          [max]="control.data.max !== undefined ? control.data.max : undefined"
          [value]="control.value"
          (change)="onChange($event)"
          (keyup)="onKeyUp($event)"
          />
      </nz-input-group>
    }
    @if (control.controlType == 'input-autocomplete') {
      <nz-input-group
        [nzSuffix]="control.data.suffix" [nzPrefix]="control.data.prefix">
        <input nz-input
          [formControlName]="control.key"
          [placeholder]="control.placeholder | actrans | str"
          [id]="control.key"
          [type]="control.type"
          [nzSize]="control.size ? (control.size == 'small' ? 'small' : (control.size == 'large' ? 'large' : 'default') ) : 'default'"
          [required]="control.required"
          [readonly]="control.data.readOnly"
          [min]="control.data.min !== undefined ? control.data.min : undefined"
          [max]="control.data.max !== undefined ? control.data.max : undefined"
          [value]="control.value"
          (change)="onChange($event)"
          [nzAutocomplete]="inputAutocomplete"
          (ngModelChange)="onAutocompleteInput($event, control)"
          />
        <!-- <nz-autocomplete [nzDataSource]="control.data.autocomplete?.options || []" nzBackfill #inputAutocomplete></nz-autocomplete> -->
        <nz-autocomplete #inputAutocomplete>
          @for (opt of control.data.autocomplete?.options || []; track opt) {
            <nz-auto-option    [nzValue]="opt.inputValue ||opt.value || opt.label || opt">{{ opt.label || opt.value || opt }}</nz-auto-option>
          }
        </nz-autocomplete>
      </nz-input-group>
    }
    @if (control.controlType == 'number-range') {
      <div  >
        <input type="hidden" [formControlName]="control.key" [id]="control.key"  />
        <input nz-input
          [type]="'number'"
          [required]="control.required"
          [disabled]="control.disabled"
          [min]="control.data.min !== undefined ? control.data.min : undefined"
          [max]="control.data.max !== undefined ? control.data.max : undefined"
          [value]="control.fc?.value[0]"
          (change)="onNumberRangeChange(0, $event)"
          />
        <span class="range-separator">
          -
        </span>
        <input nz-input
          [type]="'number'"
          [required]="control.required"
          [disabled]="control.disabled"
          [min]="control.data.min !== undefined ? control.data.min : undefined"
          [max]="control.data.max !== undefined ? control.data.max : undefined"
          [value]="control.fc?.value[1]"
          (change)="onNumberRangeChange(1, $event)"
          />
        <!--
        [placeholder]="control.placeholder"
        [placeholder]="control.placeholder"
        -->
      </div>
    }
    @if (control.controlType == 'input-number-buttons') {
      <div >
        <nz-space [nzSize]="'small'">
          <button
            *nzSpaceItem
            nz-button
            nzType="primary"
            nzShape="circle"
            (click)="decrementValue()" >
            <i nz-icon nzType="minus-circle"></i>
          </button>
          <input
            *nzSpaceItem
            nz-input
            (ngModelChange)="onChange($event)"
            [formControlName]="control.key"
            [id]="control.key"
            class="text-center"
            style="width: 50px;" />
          <button
            *nzSpaceItem
            nz-button
            nzType="primary"
            nzShape="circle"
            (click)="incrementValue()" >
            <i nz-icon nzType="plus-circle"></i>
          </button>
        </nz-space>
      </div>
    }
    @if (control.controlType == 'input-number') {
      <nz-input-number
        [formControlName]="control.key"
        [nzPlaceHolder]="control.placeholder | actrans | str"
        [id]="control.key"
        [required]="control.required"
        [nzDisabled]="control.disabled"
        (change)="onChange($event)"
        (ngModelChange)="onChange($event)"
        (nzFocus)="onInputNumberFocus()"
        (nzBlur)="onInputNumberBlur()"
        [nzMin]="control.data.min !== undefined ? control.data.min : bas.us.MIN_SAFE_INTEGER"
        [nzMax]="control.data.max !== undefined ? control.data.max : bas.us.MAX_SAFE_INTEGER"
        [nzStep]="control.data.step || 1"
        [nzPrecision]="control.data.precision"
        [nzFormatter]="numberFormatter"
        [nzParser]="numberParser"
        [class.align-right]="control.data.alignRight"
      ></nz-input-number>
    }
    <!-- [ngModel]="control.value"
    style="height: 80px;"
    -->
    <!--  -->
    @if (control.controlType == 'textarea') {
      <textarea nz-input
        [formControlName]="control.key"
        [placeholder]="control.placeholder | actrans | str"
        [id]="control.key"
        [required]="control.required"
        [nzAutosize]="control.data.autosize !== false ? (control.data.minRows || control.data.maxRows ?  { minRows: control.data.minRows || 4, maxRows: control.data.maxRows || 50 } : true) : false"
        [class.textarea-json]="control.data.json"
        [class.textarea-code]="control.data.code"
        [class.textarea-json-error]="jsonParseError"
        [value]="control.value"
        (change)="onChange($event)"
        [style.height.px]="control.data.height || null"
      ></textarea>
      @if (jsonParseError) {
        <div class="json-parse-error">JSON-parse-error</div>
      }
    }
    @if (control.controlType == 'textarea-count') {
      <nz-textarea-count
        [nzMaxCharacterCount]="control.data.max">
        <textarea nz-input
          [formControlName]="control.key"
          [placeholder]="control.placeholder | actrans | str"
          [id]="control.key"
          [required]="control.required"
          [nzAutosize]="true"
          [style.height.px]="control.data.height || 60"
          [value]="control.value"
          (change)="onChange($event)"
        ></textarea>
      </nz-textarea-count>
    }
    @if (control.controlType == 'tree-select') {
      <div
        >
        <nz-tree-select
          [id]="control.key"
          [formControlName]="control.key"
          [nzPlaceHolder]="control.placeholder | actrans | str"
          [nzMaxTagCount]="control.data.maxTagCount || 3"
          [nzMaxTagPlaceholder]="omittedPlaceHolder"
          [nzNodes]="(control.optionsList || control.options())"
          [nzDefaultExpandAll]="control.data.defaultExpandAll"
          [nzAllowClear]="control.data.allowClear"
          [nzVirtualHeight]="control.data.virtualHeight"
          [nzMultiple]="control.data.multiple"
          (ngModelChange)="onModelChange($event)"
        ></nz-tree-select>
        <ng-template #omittedPlaceHolder let-omittedValues>og {{ omittedValues.length }} flere...</ng-template> <!-- TODO:text -->
        <!--
        style="width: 250px"
        -->
      </div>
    }
    @if (control.controlType == 'richtext') {


      <quill-editor
        [formControlName]="control.key"
        [placeholder]="control.placeholder | actrans | str"
        [modules]="quillModules"
        (onBlur)="onEditorBlur($event)"
        (onEditorCreated)="onEditorCreated($event)"
        [debounceTime]="500"
        #quillEditor
      ></quill-editor>
    }
    <!-- (onContentChanged)="onContentChanged($event)"-->
    @if (control.controlType == 'select') {
      <nz-select
        #controlSelect
        [id]="control.key"
        [formControlName]="control.key"
        [nzPlaceHolder]="control.placeholder | actrans | str"
        [nzBackdrop]="control.data.backdrop"
        [nzDisabled]="control.disabled"
        [nzShowSearch]="control.data.showSearch === undefined || control.data.showSearch === true"
        [nzMode]="control.selectMode || 'default'"
        [(nzOpen)]="control.data.open"
        (nzOpenChange)="onOpenChange($event)"
        (ngModelChange)="onModelChange($event, controlSelect)"
        >
        @if (control.optionsAllowEmpty) {
          <nz-option
            nzValue=""
            [nzLabel]="control.optionsEmptyLabel | actrans | str"
          ></nz-option>
        }
        @for (opt of (control.optionsList || control.options()); track opt) {
          <nz-option
            [nzValue]="control.optionsFieldValue === 'OBJECT' ? opt : opt[control.optionsFieldValue]"
            [nzLabel]="control.optionsFieldLabel === 'OBJECT' ? opt : opt[control.optionsFieldLabel] | actrans:{fallbackKey:true} | str"
            [nzDisabled]="opt.disabled"
          ></nz-option>
        }
      </nz-select>
    }
    @if (control.controlType == 'telephone') {
      <!--
        [formControlName] ligger direkte på det synlige feltet (via en egen
        ControlValueAccessor-direktiv, btTelephoneValueAccessor). Dette er
        nødvendig for at NG-ZORRO sin automatiske rød-ramme/feilmelding
        ("Feltet er påkrevd") skal fungere, siden nz-input-direktivet leser
        sin egen NgControl for å pushe valideringsstatus til nz-form-item.
        Direktivet sørger for at selve FormControl-verdien alltid er HELE
        telefonnummeret (prefix + lokalnummer), mens kun lokalnummeret vises
        i input-feltet.
      -->
      <nz-input-group
        [nzAddOnBefore]="telephonePrefixTemplate"
        [nzSuffix]="control.data.suffix"
        [nzStatus]="telephoneStatus"
        >
        <input nz-input
          btTelephoneValueAccessor
          [formControlName]="control.key"
          [id]="control.key"
          [type]="'tel'"
          [placeholder]="control.placeholder | actrans | str"
          [required]="control.required"
          [readonly]="control.data.readOnly"
        />
      </nz-input-group>
      <ng-template #telephonePrefixTemplate>
        <nz-select
          #telephonePrefixSelect
          class="telephone-prefix-select"
          [nzShowSearch]="true"
          [nzAllowClear]="false"
          [nzBackdrop]="control.data.backdrop"
          [nzDisabled]="control.disabled"
          [nzPlaceHolder]="'+'"
          [nzDropdownMatchSelectWidth]="false"
          [nzDropdownStyle]="telephonePrefixDropdownStyle"
          [ngModel]="telephonePrefixValue"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onTelephonePrefixChange($event)"
          >
          @for (opt of telephonePrefixOptions; track opt) {
            <nz-option
              [nzValue]="opt.dialCode"
              [nzLabel]="opt.dialCode + ' ' + opt.name"
              [nzCustomContent]="true"
              >
              <span class="phone-prefix-option">
                <span class="phone-prefix-flag">{{ opt.flag }}</span>
                <span class="phone-prefix-dial">{{ opt.dialCode }}</span>
                @if (opt.name) {
                  <span class="phone-prefix-name">{{ opt.name }}</span>
                }
              </span>
            </nz-option>
          }
        </nz-select>
      </ng-template>
    }
    @if (control.controlType == 'checkbox-list') {
      <div  >
        <div >
          {{ control.mk ? (control.mk | actrans) : control.label }}
          @if (options.showRequiredStar && control.required) {
            <span>&nbsp;*</span>
          }
        </div>
        <!--
        [id]="control.key"
        [formControlName]="control.key"
        (ngModelChange)="onModelChange($event)"
        -->
        <div nz-row>
          @for (opt of (control.optionsList || control.options()); track opt) {
            <div nz-col nzSpan="24">
              <label nz-checkbox
                [ngModel]="isChecked(opt[control.optionsFieldValue])"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onCheckboxChange(opt[control.optionsFieldValue], $event)">
                {{ opt[control.optionsFieldLabel] | actrans:{fallbackKey:true}  }}
              </label>
            </div>
          }
        </div>
        @if (!isValid) {
          <div nz-typography nzType="danger">
            {{ 'app.lib.error.form.required' | actrans }}
          </div>
        }
      </div>
    }
    @if (control.controlType == 'radio-button') {
      <nz-radio-group
        [id]="control.key"
        [formControlName]="control.key"
        [nzButtonStyle]="control.radioButtonStyle || 'solid'"
        [nzSize]="control.data.size"
        (ngModelChange)="onModelChange($event)"
        >
        @for (opt of (control.optionsList || control.options()); track opt) {
          <label
            nz-radio-button
            [nzDisabled]="!!opt.disabled"
            [nzValue]="opt[control.optionsFieldValue]"
            >
            {{ opt[control.optionsFieldLabel] | actrans:{fallbackKey:true}  }}
          </label>
        }
        @if (control.optionsAllowEmpty) {
          <label  nz-radio-button     nzValue=""   >
            {{ control.optionsEmptyLabel | actrans:{fallbackKey:true}  }}
          </label>
        }
      </nz-radio-group>
    }
    @if (control.controlType == 'radio') {
      <nz-radio-group
        [id]="control.key"
        [formControlName]="control.key"
        (ngModelChange)="onModelChange($event)"
        class="radio-vertical"
        >
        @for (opt of (control.optionsList || control.options()); track opt) {
          <label
            nz-radio
            [nzValue]="opt[control.optionsFieldValue]"
            >
            {{ opt[control.optionsFieldLabel] | actrans:{fallbackKey:true}  }}
          </label>
        }
      </nz-radio-group>
    }
    @if (control.controlType == 'slider') {
      <nz-row
        [nzGutter]="8"
        >
        <nz-col [nzSpan]="control.data.sliderSpan || 18" >
          <nz-slider
            [id]="control.key"
            [formControlName]="control.key"
            [nzMin]="control.data.min || 1"
            [nzMax]="control.data.max || 100"
            [nzStep]="control.data.step || 1"
            [required]="control.required"
            (ngModelChange)="onModelChange($event)"
          ></nz-slider>
        </nz-col>
        <div nz-col [nzSpan]="24 - (control.data.sliderSpan || 18)">
          <!-- <nz-input-group
          [nzSuffix]="control.data.suffix"
          [nzPrefix]="control.data.prefix"> -->
          <nz-input-number
            [nzMin]="control.data.min || 1"
            [nzMax]="control.data.max || 100"
            [nzStep]="control.data.step || 1"
            [required]="control.required"
            [nzFormatter]="numberFormatter"
            [nzParser]="numberParser"
            [(ngModel)]="control.data.sliderInput" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onSliderInputChange($event)"
          ></nz-input-number>
        <!-- </nz-input-group> -->
      </div>
    </nz-row>
  }
  @if (control.controlType == 'slider-range') {
    <nz-row
      [nzGutter]="8"
      >
      <div nz-col nzSpan="6">
        <nz-input-number
          [nzMin]="control.data.min || 1"
          [nzMax]="control.data.max || 100"
          [nzStep]="control.data.step || 1"
          [required]="control.required"
          [nzFormatter]="numberFormatter"
          [nzParser]="numberParser"
          [(ngModel)]="control.data.sliderInputMin" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onSliderRangeInputChange(0, $event)"
        ></nz-input-number>
      </div>
      <nz-col nzSpan="12" >
        <nz-slider
          nzRange
          [id]="control.key"
          [formControlName]="control.key"
          [nzMin]="control.data.min || 1"
          [nzMax]="control.data.max || 100"
          [nzStep]="control.data.step || 1"
          [required]="control.required"
          (ngModelChange)="onModelChange($event)"
        ></nz-slider>
      </nz-col>
      <div nz-col nzSpan="6">
        <nz-input-number
          [nzMin]="control.data.min || 1"
          [nzMax]="control.data.max || 100"
          [nzStep]="control.data.step || 1"
          [required]="control.required"
          [nzFormatter]="numberFormatter"
          [nzParser]="numberParser"
          [(ngModel)]="control.data.sliderInputMax" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onSliderRangeInputChange(1, $event)"
        ></nz-input-number>
      </div>
    </nz-row>
  }
  @if (control.controlType == 'mbsc-datepicker') {
    <nz-input-group
      nzPrefixIcon="calendar"
      [nzSuffixIcon]="control.data.suffix"
      >
      <input
        class="ant-input"
        [id]="control.key"
        [formControlName]="control.key"
        mbsc-datepicker
        [controls]="['calendar']"
        [dateFormat]="control.data.dateFormat || 'YYYY-MM-DD'"
        select="date"
        display="anchored"
        [invalid]="mbscDatepickerInvalid"
        [min]="control.data.minDate"
        [max]="control.data.maxDate"
        (onPageLoading)="mbscDatepickerOnPageLoading($event)"
        (onChange)="mbscDatepickerOnChange($event)"
        />
    </nz-input-group>
  }
  @if (control.controlType == 'mbsc-datepicker-multiple') {
    <nz-input-group
      nzPrefixIcon="calendar"
      [nzSuffixIcon]="control.data.suffix"
      >
      <!-- TODO -->
      <input
        class="ant-input"
        [id]="control.key"
        [formControlName]="control.key"
        mbsc-datepicker
        [controls]="['calendar']"
        [dateFormat]="control.data.dateFormat || 'YYYY-MM-DD'"
        select="date"
        display="anchored"
        [invalid]="mbscDatepickerInvalid"
        [min]="control.data.minDate"
        [max]="control.data.maxDate"
        [selectMultiple]="true"
        (onPageLoading)="mbscDatepickerOnPageLoading($event)"
        (onChange)="mbscDatepickerOnChange($event)"
        />
    </nz-input-group>
  }
  @if (control.controlType == 'date-picker') {
    <nz-input-group
      [nzSuffix]="control.data.suffix"
      [nzPrefix]="control.data.prefix"
      >
      <nz-date-picker
        [id]="control.key"
        [formControlName]="control.key"
        (ngModelChange)="onModelChange($event)"
        [nzFormat]="control.data.format || 'yyyy-MM-dd'"
        [nzInputReadOnly]="control.data.readOnly !== undefined ? control.data.readOnly : bas.ui.r.xs"
        [nzDisabled]="!!control.data.disabled"
        [nzInline]="control.data.inline"
        [nzPlaceHolder]="control.placeholder | actrans:{fallbackKey:true}  | str"
      ></nz-date-picker>
    </nz-input-group>
  }
  @if (control.controlType == 'date-picker-multiple') {
    <nz-input-group
      nzPrefixIcon="calendar"
      [nzSuffixIcon]="control.data.suffix"
      >
      <input
        class="ant-input"
        [id]="control.key"
        [formControlName]="control.key"
        [value]="datePickerMultipleValue"
        readonly
        [placeholder]="control.placeholder | actrans:{fallbackKey:true} | str"
        (click)="datePickerMultipleOpen()"
        />
    </nz-input-group>
    @if (datePickerMultipleVisible) {
      <div class="date-picker-multiple-backdrop" (click)="datePickerMultipleClose()"></div>
      <div class="date-picker-multiple-popup">
        <nz-date-picker
          [nzOpen]="true"
          [nzInline]="true"
          [nzShowToday]="false"
          [nzDisabledDate]="pickerDisabledDate"
          [nzDateRender]="datePickerMultipleTplRender"
          [nzRenderExtraFooter]="datePickerMultipleFooterTpl"
          (nzOnCalendarChange)="datePickerMultipleDateClick($event)"
          style="opacity: 0; position: absolute; width: 0; height: 0;"
        ></nz-date-picker>
        <!--  -->
        <ng-template #datePickerMultipleTplRender let-current>
          <div
            class="ant-picker-cell-inner"
            [class.date-picker-multiple-selected]="datePickerMultipleIsSelected(current)"
            (click)="datePickerMultipleToggleDate(current); $event.stopPropagation()">
            {{ current.getDate() }}
          </div>
        </ng-template>
        <ng-template #datePickerMultipleFooterTpl>
          <div class="date-picker-multiple-footer">
            <button nz-button nzType="default" nzSize="small" (click)="datePickerMultipleClose()">
              <span nz-icon nzType="close" nzTheme="outline"></span> {{ 'common.close' | actrans }}
            </button>
          </div>
        </ng-template>
      </div>
    }
  }
  <!-- <ng-template #prefixTemplateCommon><span nz-icon [nzType]="control.data.prefix"></span></ng-template>
  <ng-template #suffixTemplateCommon><span nz-icon [nzType]="control.data.suffix"></span></ng-template> -->
  @if (control.controlType == 'datetime-picker') {
    <nz-date-picker
      [id]="control.key"
      [formControlName]="control.key"
      (ngModelChange)="onModelChange($event)"
      [nzShowTime]="{ nzFormat: 'HH:mm', nzMinuteStep: control.data.minuteStep || 5 }"
      [nzFormat]="control.data.format || 'yyyy-MM-dd HH:mm'"
      [nzInputReadOnly]="control.data.readOnly !== undefined ? control.data.readOnly : bas.ui.r.xs"
      [nzInline]="control.data.inline"
      [nzAllowClear]="!!control.data.allowClear"
    ></nz-date-picker>
  }
  @if (control.controlType == 'date-range-picker') {
    <nz-range-picker
      [id]="control.key"
      [formControlName]="control.key"
      (ngModelChange)="onChange($event)"
      [nzFormat]="control.data.format || 'yyyy-MM-dd'"
      [nzInputReadOnly]="control.data.readOnly"
      [nzInline]="control.data.inline"
      [nzDisabledDate]="pickerDisabledDate"
      (nzOnOpenChange)="onOpenChange($event)"
    ></nz-range-picker>
  }
  @if (control.controlType == 'bt-date-range-picker') {
    <nz-input-group
      [nzSuffix]="control.data.suffix"
      [nzPrefix]="control.data.prefix"
      >
      <nz-date-picker
        [(ngModel)]="control.fc!.value[0]"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onDateRangeChange(0, $event)"
        [nzFormat]="control.data.format || 'yyyy-MM-dd'"
        [nzInputReadOnly]="control.data.readOnly !== undefined ? control.data.readOnly : bas.ui.r.xs"
        [nzInline]="control.data.inline"
        [nzDisabledDate]="pickerDisabledDate"
        [nzPlaceHolder]="control.placeholder | actrans:{fallbackKey:true}  | str"
        style="width: auto;"
      ></nz-date-picker>
      <div style="display: inline-flex;" class="mx-d"> <span nz-icon nzType="arrow-right" nzTheme="outline"></span> </div>
      <nz-date-picker
        [(ngModel)]="control.fc!.value[1]"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onDateRangeChange(1, $event)"
        [nzFormat]="control.data.format || 'yyyy-MM-dd'"
        [nzInputReadOnly]="control.data.readOnly !== undefined ? control.data.readOnly : bas.ui.r.xs"
        [nzInline]="control.data.inline"
        [nzDisabledDate]="pickerDisabledDateRangeEnd"
        [nzPlaceHolder]="control.placeholder | actrans:{fallbackKey:true}  | str"
        style="width: auto;"
      ></nz-date-picker>
    </nz-input-group>
  }
  <!-- <nz-range-picker
  *ngIf="control.controlType == 'time-range-picker'"
  [id]="control.key"
  [formControlName]="control.key"
  (ngModelChange)="onChange($event)"
  [nzFormat]="control.data.format || 'HH:mm'"
  [nzInputReadOnly]="control.data.readOnly"
  [nzInline]="control.data.inline"
></nz-range-picker> -->
@if (control.controlType == 'datetime-range-picker') {
  <nz-range-picker
    [id]="control.key"
    [formControlName]="control.key"
    [nzShowTime]="{ nzFormat: 'HH:mm', nzMinuteStep: control.data.minuteStep || 5 }"
    [nzFormat]="control.data.format || 'yyyy-MM-dd HH:mm'"
    [nzInputReadOnly]="control.data.readOnly"
    [nzInline]="control.data.inline"
    (ngModelChange)="onChange($event)"
  ></nz-range-picker>
}
<!--
ngModel
(nzOnCalendarChange)="onCalendarChange($event)"
(nzOnOk)="onOk($event)"
-->
@if (control.controlType == 'time-picker') {
  <nz-time-picker
    [id]="control.key"
    [formControlName]="control.key"
    (ngModelChange)="onModelChange($event)"
    [nzFormat]="control.data.format || 'HH:mm'"
    [nzMinuteStep]="control.data.minuteStep || 5"
  ></nz-time-picker>
}
@if (control.controlType == 'tags') {
  <div>
    @if (control.data.selectAll) {
      <nz-tag
        class="tags-all"
        nzMode="checkable"
        [nzChecked]="tagsIsAllSelected()"
      (nzCheckedChange)="tagsChange($event, -1)">{{ 'common.all' | actrans }}</nz-tag>
    }
    @if (control.data.selectAll) {
      <span    style="margin-right: 8px;">|</span>
    }
    @for (opt of (control.optionsList || control.options()); track opt) {
      <nz-tag
        nzMode="checkable"
        [nzChecked]="tagsIsSelected(opt)"
      (nzCheckedChange)="tagsChange($event, opt)">{{ opt[control.optionsFieldLabel] | actrans }}</nz-tag>
    }
  </div>
}
@if (control.controlType == 'weekdays') {
  <div>
    <!-- nzColor="#cd201f" -->
    @if (control.data.textLength != 'min' || true) {
      <nz-tag
        class="weekdays-all"
        nzMode="checkable"
        [nzColor]="control.disabled ? (isAllWeekdays(control.fc?.value) ? '#FF0000' : '#FF7777') : undefined"
        [class.cursor-not-allowed]="control.disabled"
        [nzChecked]="isAllWeekdays(control.fc?.value)"
        (nzCheckedChange)="weekdayCheckChange($event, -1)"
        [style.margin-right]="control.data.textLength == 'min' ? '2px' : '8px'"
        >
        {{ 'common.all' | actrans }}
      </nz-tag>
    }
    @if (control.data.textLength != 'min') {
      <span  [style.margin-right]="control.data.textLength == 'min' ? '2px' : '8px'">|</span>
      }  <!-- style="margin-right: 8px;"  -->
      @for (wd of [2,3,4,5,6,7,1]; track wd) {
        <nz-tag
          nzMode="checkable"
          [nzColor]="control.disabled ? (control.fc?.value[wd] ? '#FF0000' : '#FF7777') : undefined"
          [class.cursor-not-allowed]="control.disabled"
          [nzChecked]="control.fc?.value[wd]"
          (nzCheckedChange)="weekdayCheckChange($event, wd)"
          [style.margin-right]="control.data.textLength == 'min' ? '2px' : '8px'"
          >
          {{ (control.data.textLength == 'min' ? ('common.weekday.'+wd+'.min') : ('common.weekday.' + wd)) | actrans }}
        </nz-tag>
      }
    </div>
  }
  @if (control.controlType == 'order-status') {
    <div>
      <!-- nzColor="#cd201f" -->
      <nz-tag
        class="status-all"
        nzMode="checkable"
        [nzChecked]="isAllBoolMap(control.fc?.value)"
      (nzCheckedChange)="boolMapCheckChange($event, -1)">{{ 'common.all' | actrans }}</nz-tag>
      <span style="margin-right: 8px;">|</span>
      @for (status of [0,1,2,3,4,5,6]; track status) {
        <nz-tag
          nzMode="checkable"
          [nzChecked]="control.fc?.value[status]"
        (nzCheckedChange)="boolMapCheckChange($event, status)">{{ control.data.statusList[status].mk | actrans }}</nz-tag>
      }
    </div>
  }
  @if (control.controlType == 'switch') {
    <div>
      <nz-switch
        [id]="control.key"
        [formControlName]="control.key"
        [nzDisabled]="control.disabled"
        [required]="control.required"
      ></nz-switch>
      <!-- <label>
      <span>{{ control.mk ? (control.mk | actrans) : control.label }}</span>
    </label> -->
  </div>
}
@if (control.controlType == 'upload') {
  <div>
    <h3>
      {{ control.mk ? (control.mk | actrans) : control.label }}
      @if (options.showRequiredStar && control.required) {
        <span>&nbsp;*</span>
      }
    </h3>
    <nz-upload
      nzType="drag"
      [nzMultiple]="true"
      [nzAction]="uploadUrl()"
      [nzHeaders]="uploadHeaders"
      [(nzFileList)]="control.data.upload.fileList"
      [nzFileType]="control.data.upload?.fileType || 'image/png,image/jpeg,application/pdf'"
      nzListType="text"
      [nzShowUploadList]="{ showRemoveIcon: true }"
      (nzChange)="handleUploadFile($event, control)"
      >
      <p class="ant-upload-drag-icon">
        <i nz-icon nzType="inbox"></i>
      </p>
      <p class="ant-upload-text">
        {{ 'app.cbapi5.page.admin.product.clickOrDragFilesHere' | actrans }}
      </p>
      <p class="ant-upload-hint">
        {{ 'app.cbapi5.page.admin.product.uploadFilesHint' | actrans }}
        @if (control.data.upload.fileTypeDisplay) {
          <span class="fgc-red"><br/>{{ control.data.upload.fileTypeDisplay }}</span>
        }
      </p>
    </nz-upload>
    @if (control.required && !control.data.upload?.fileList?.length) {
      <div nz-typography nzType="danger">
        {{ 'app.lib.error.form.upload.required' | actrans }}
      </div>
    }
  </div>
}
@if (control.controlType == 'checkbox') {
  <label
    nz-checkbox
    [id]="control.key"
    [formControlName]="control.key"
    [nzDisabled]="control.disabled"
    [required]="control.required"
    (ngModelChange)="onModelChange($event)"
    >
    <!--       [ngModel]="control.value"    [ngModelOptions]="{standalone: true}", fungerer bare sammen med dobbel-binding:  [(ngModel)] -->
    @if (!options.hideLabel) {
      <span>{{ control.mk ? (control.mk | actrans) : control.label }}</span>
    }
    @if (options.showRequiredStar && control.required) {
      <span> *</span>
    }
    @if (control.mkInfo) {
      <i
        class="mkInfoIcon"
        nz-icon [nzType]="'info-circle'"
        nz-tooltip
      [nzTooltipTitle]="control.mkInfo | actrans | str" ></i>
    }
  </label>
}
@if (control.controlType == 'label') {
  <label
    >
    <!--       [class.text-right]="control.data.alignRight"  -->
    <span class="text-bold " [innerHTML]="control.data.html ? control.value : control.value">
      <!-- {{ control.value }} -->
    </span>
    @if (control.mkInfo) {
      <i
        class="mkInfoIcon"
        nz-icon [nzType]="'info-circle'"
        nz-tooltip
      [nzTooltipTitle]="control.mkInfo | actrans | str" ></i>
    }
  </label>
}
@if (control.controlType == 'link') {
  <label
    >
    <!--       [class.text-right]="control.data.alignRight"  -->
    <a [href]="control.data.href || '#'" (click)="onClick($event, control)" class="text-bold " [innerHTML]="control.data.html ? control.value : control.value">
      <!-- {{ control.value }} -->
    </a>
    @if (control.mkInfo) {
      <i
        class="mkInfoIcon"
        nz-icon [nzType]="'info-circle'"
        nz-tooltip
      [nzTooltipTitle]="control.mkInfo | actrans | str" ></i>
    }
  </label>
}
</nz-form-control>
@if (control.mkHelpText) {
  <bt-alert [mk]="control.mkHelpText"></bt-alert>
}
</nz-form-item>
}
<!-- <div class="errorMessage" *ngIf="!isValid">
{{ control.mk ? (control.mk | actrans) : control.label }} er påkrevd
</div> -->
